
import CommonUtils from "@/common-utils";
import Ugcs from "@/components/Ugcs.vue";
import { ProductVO, RecentProductVO } from "@/views/biz/product/vo/product.vo";
import { GTagEventRequestVO, ItemsVO } from "@/vo/common.vo";
import axios from "axios";
import "firebase/analytics";
import firebase from "firebase/app";
import throttle from "lodash-es/throttle";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Constants from "../../../constants";
import { OrderMetaVO } from "../order/vo/order.vo";
import Criteo from "@/criteo";
import { CriteoVO } from "@/vo/criteo.vo";
import { FacebookVO } from "@/vo/facebook.vo";
import CommonModalDialog from "@/components/CommonModalDialog.vue";
import BottomSheets from "@/components/BottomSheets.vue";
import AdLogs from "@/ad-logs";

@Component({
  components: { Ugcs, CommonModalDialog, BottomSheets },
})
export default class Product extends Vue {
  @Prop() productCd!: string;
  // 좆아요 이벤트
  onHeartActivated = false;
  onHeartDeactivated = false;

  // 그룹 상품 포함
  product: ProductVO = {} as ProductVO;
  // 그룹 상품 중 현재 선택 된 상품
  currentProduct: ProductVO = {} as ProductVO;
  //메타정보
  meta: OrderMetaVO = {} as OrderMetaVO;

  showGroups = false; // 옵션 펼치기
  showMainImgAsFullscreen = false; // 이미지 크게 보기

  viewMore = false;

  // 상품 구매 수량
  orderQuantityRaw = 1;

  // 상단 네비게이션
  currentScroll = "product";
  fixNavigation = false;

  // 상품 이미지 swiper
  swiperProductImg = {
    centeredSlides: true,
    slidesPerView: 1,
    pagination: { el: ".swiper-pagination-product" },
    autoplay: { delay: 3000, disableOnInteraction: false },
    lazy: true,
    loop: true,
  };
  // 프로모션 태그 swiper
  swiperPromotionOption = {
    slidesPerView: "auto",
    spaceBetween: 3,
  };
  // 브랜드 상품 swiper
  swiperBrandProducts = {
    slidesPerView: 3.2,
    spaceBetween: this.$isMobile ? 10 : 20,
    freeMode: true,
    lazy: true,
  };
  //상품상세 더보기
  proudctDetailMore = false;


  @Watch("product.brandCd")
  onChangedForBrandCd(): void {
    if (this.product.brandCd) {
      this.getMoreProductDetail();
    }
  }

  ///////////////////////////////// computed

  // 구매수량
  get orderQuantity(): number {
    if (this.isSoldOut) {
      // 품절이면
      return 0;
    }
    // 최대구매수량 안넘어가게
    if (this.orderQuantityRaw > this.maxOrderQuantity) {
      this.orderQuantityRaw = this.maxOrderQuantity;
    }
    return this.orderQuantityRaw;
  }

  // 주문액
  get orderPrice(): number {
    return this.orderQuantity * (this.currentProduct.salePrice * 1);
  }

  // 품절임?
  get isSoldOut(): boolean {
    if (!this.currentProduct) {
      return true;
    }

    return this.maxOrderQuantity < 1;
  }
  // 전체품절임?
  get isAllSoldOut(): boolean {
    if (
      this.product &&
      this.product.groups &&
      (!this.product.groups.length || this.product.groups.length <= 1)
    ) {
      // 그룹 상품인데 옵션이 1개면
      return this.isSoldOut;
    }
    // 그룹 상품이면서 옵션이 2개 이상이면
    return false; // 판단 못함
  }

  // 최대구매수량
  get maxOrderQuantity(): number {
    return Math.min(
      this.currentProduct.stockCnt,
      this.currentProduct.maxOrderCnt
    );
  }

  // 판매 중지임?
  get isStopSelling(): boolean {
    return this.currentProduct && this.currentProduct.viewType != "01";
  }

  // 살 수 있는 등급임? (현재는 첫구매이벤트 참여 가능 여부만 봄)
  get gradePermitted(): boolean {
    if (!this.currentProduct) {
      return false;
    }
    // 첫구매전용상품 && 권한 없음
    if (
      this.currentProduct.restrctMemGrade ==
        Constants.MEM_GRADE_FIRST_PURCHASE &&
      !this.currentProduct.gradePermitted
    ) {
      return false;
    }
    return true;
  }

  // 기본 구매하기 버튼 노출
  get showDefaultBuyBtn(): boolean {
    return (
      !this.isStopSelling &&
      this.gradePermitted &&
      !this.product.isRaffleProduct
    );
  }

  // 리뷰 평점
  get productReviewRatingAvg(): string {
    return this.product.reviewSummary.ratingSummary * 20 + "%";
  }

  // 공유 링크
  get sharedUrl(): string {
    return `${process.env.VUE_APP_MAIN_URL}product/${this.productCd}`;
  }

  // 상품 설명(SEO)
  get seoDescription(): string {
    const p = this.product;
    // [{0} {1}] {2} / {3} / {4}% 할인 -> 판매가 \\{5}(소비자가 \\{6}) / {7} / 집으로 오는 면세쇼핑, 지쿠
    return this.$t("product.t0003", [
      p.brandNm,
      p.brandEngNm,
      p.productNm,
      p.discountRate,
      CommonUtils.toPrice(p.salePrice),
      CommonUtils.toPrice(p.orgPrice),
      p.repFullCateNm,
      p.productSeo,
    ]).toString();
  }

  // 쿠폰 최대 할인가
  get maxCouponDiscountAmount() {
    if (!this.product.maxCouponDiscountAmount) {
      return 0;
    }
    return this.product.maxCouponDiscountAmount;
  }

  // 슬라이드 사용함?
  get isUsingSlides() {
    // 상품 이미지 2개 이상
    return this.product.images && this.product.images.length > 1;
  }
  //네비바(리뷰, 문의, 상세) 클릭 시 위치 조정
  get currentScrollOffset() {
    return !this.$isMobile ? -105 : -94;
  }
  ///////////////////////////////// methods

  // 옵션 변경
  setcurrentProduct(productCd: number): void {
    axios.get(`/product/${productCd}`).then((r) => {
      this.currentProduct = r.data as ProductVO;
    });
  }

  // 구매 수량 조절
  setOrderQuantity(amt: number) {
    const newOrderQuantity = this.orderQuantity + amt;
    if (newOrderQuantity > 0 && newOrderQuantity <= this.maxOrderQuantity) {
      this.orderQuantityRaw = newOrderQuantity;
    } else if (newOrderQuantity > this.maxOrderQuantity) {
      // 최대 구매 수량을 초과할 수 없습니다.
      this.$toast(this.$t("t0110"));
    }
  }

  // 스크롤 따라서 상단 navigation 제어
  handleScroll = throttle(this.handleTopNavigation, 150);
  handleTopNavigation(): void {
    if (!this.product.productCd) return;

    let scrollY = window.scrollY;
    if (this.$isMobile) {
      scrollY = scrollY + 100;
    } else {
      scrollY = scrollY - 120;
    }
    const navigation = this.$refs.navigation as HTMLElement;
    const review = this.$refs.review as HTMLElement;
    const qna = this.$refs.qna as HTMLElement;
    const detail = this.$refs.detail as HTMLElement;
    this.fixNavigation = navigation.offsetTop <= scrollY; // 스크롤이 navigation 아래로 내려가면 고정
    if (scrollY > qna.offsetTop) {
      this.currentScroll = "qna";
    } else if (scrollY > detail.offsetTop) {
      this.currentScroll = "detail";
    } else if (scrollY > review.offsetTop) {
      this.currentScroll = "review";
    } else {
      this.currentScroll = "";
    }
  }

  // 바로결제/장바구니
  goOrder(type: string): void {
    const params = {
      toName: "Product",
      productCd: this.currentProduct.productCd.toString(),
      count: this.orderQuantityRaw.toString(),
      orderCount: this.orderQuantityRaw.toString(),
      salesPrice: this.currentProduct.salePrice.toString(),
    };

    // 일단 로그인 체크하고
    axios.get("/login/ping").then((r) => {
      if (r.data != "pong") {
        this.$router.push({ name: "Login", params: params });
        return;
      }

      // 첫구매 이벤트
      if (
        this.currentProduct.restrctMemGrade ==
        Constants.MEM_GRADE_FIRST_PURCHASE
      ) {
        // 첫구매 이벤트 상품은 {0}원 이상 주문 시 구매 가능합니다. 장바구니에 상품을 담으시겠습니까?
        if (
          confirm(
            this.$t("product.c0002", [
              this.currentProduct.firstPurchaseMinOrderPrice,
            ]).toString()
          ) == false
        ) {
          return;
        }
        type = "cart";
      }

      // 로그인 성공 하면
      switch (type) {
        case "cart":
          this.goCart(params);
          break;
        case "payment":
          this.goPayment([params]);
          break;
      }
    });
  }

  // 장바구니
  goCart(params: object): void {
    axios.post("/order/cart", params).then((r) => {
      //파이어베이스 장바구니 추가 태그
      this.sendAnayticsLogEvents(firebase.analytics.EventName.ADD_TO_CART);

      //크리테오 장바구니 추가 태그
      // Criteo.putQuery({
      //   path : '',
      //   oneTag : Criteo.criteoTags.CART_ADD_TAG,
      //   data : [{
      //     productCd:this.product.productCd,
      //     salePrice:this.product.salePrice
      //   }] as any[]
      // } as CriteoVO);

      // 페이스북 픽셀 장바구니 추가 태그
      AdLogs.sendMetaPixelEventLogs("AddToCart", this.fbPixelParams());

      // 잘 담겼습니다. 장바구니로 이동?
      if (confirm(this.$t("product.c0001").toString())) {
        // ㅇㅇ
        this.$router.push({ name: "OrderCart" });
      } else {
        this.$store.dispatch("updateCartCount");
      }
    });
  }

  // 결제
  goPayment(params: Array<object>): void {
    axios
      .post("/order/product/order", params)
      .then((r) => {
        const orderCd = r.data as string;
        this.$router.push({
          name: "OrderPayment",
          params: { orderCd: orderCd },
        });
      })
      .catch(() => {
        //TODO 실패 사유
      });
  }

  // 최근 본 상품에 추가
  addRecentProduct(): void {
    let recentProducts = CommonUtils.getLocalStorageObject(
      Constants.RECENT_PRODUCTS
    );
    if (!recentProducts) {
      recentProducts = new Array<number>();
    }

    recentProducts.unshift(this.productCd);
    recentProducts = Array.from(new Set(recentProducts));

    if (recentProducts.length > 20) {
      recentProducts = recentProducts.slice(undefined, 20);
    }

    CommonUtils.putLocalStorageObject(
      Constants.RECENT_PRODUCTS,
      recentProducts
    );

    this.addRecentProductInfo();
  }

  // 최근 본 상품정보 추가
  addRecentProductInfo() {
    let recentProductInfo = CommonUtils.getLocalStorageObject(
      Constants.RECENT_PRODUCTS_INFO
    ) as Array<RecentProductVO>;
    if (!recentProductInfo) {
      recentProductInfo = new Array<RecentProductVO>();
    }

    const index = recentProductInfo.findIndex(
      (item) => item.productCd == this.product.productCd
    );

    // 중복 제거
    if (index > -1) {
      recentProductInfo.splice(index, 1);
    }

    recentProductInfo.unshift({
      productCd: this.product.productCd,
      productNm: this.product.productNm,
      imgMainUrl: this.product.imgMainUrl,
    });

    if (recentProductInfo.length > 20) {
      recentProductInfo = recentProductInfo.slice(undefined, 20);
    }

    // 로컬스토리지 저장
    CommonUtils.putLocalStorageObject(
      Constants.RECENT_PRODUCTS_INFO,
      recentProductInfo
    );

    // Vuex 업데이트
    this.$store.commit("recentProductInfo", recentProductInfo);
  }

  // SNS 공유
  sharedProductUrlToSns(platform: string) {
    switch (platform) {
      case "kakao": {
        const imageUrl = this.currentProduct.imgMainUrl;
        const title = this.currentProduct.productNm;
        (this as any).$kakao.Share.sendDefault({
          objectType: "feed",
          content: {
            title: title,
            description: "집으로 오는 면세쇼핑 지쿠",
            imageUrl: imageUrl,
            link: {
              mobileWebUrl: this.sharedUrl,
              webUrl: this.sharedUrl,
            },
          },
          buttons: [
            {
              title: "웹으로 보기",
              link: {
                mobileWebUrl: this.sharedUrl,
                webUrl: this.sharedUrl,
              },
            },
            {
              title: "앱으로 보기",
              link: {
                mobileWebUrl: `https://zikoo.co.kr/zlink?target=product/${this.product.productCd} `,
              },
            },
          ],
        });

        break;
      }
      case "facebook":
        location.href = `http://www.facebook.com/sharer/sharer.php?u=${this.sharedUrl}`;
        break;
      case "instagram":
        // 공유 안되는 것 같음
        break;
      case "copy": {
        const textarea = document.createElement("textarea");
        textarea.value = this.sharedUrl;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);

        // 복사되었습니다.
        this.$toast(this.$t("product.a0001"));
        break;
      }
      default:
        break;
    }
  }

  // 좋아요
  btnLike() {
    CommonUtils.zzimProduct(this.product).then(() => {
      this.onHeartActivated = false;
      this.onHeartDeactivated = false;

      // TODO memByLike 변수명 변경(DB까지 이걸로 되어 있어서 도저히 귀찮아서 지금은 못바꿈)
      this.product.memByLike = Math.abs(this.product.memByLike - 1); // 0이면 1, 1이면 0

      // 좋아요(하트) 버튼 누르면 이벤트 발생함
      if (this.product.memByLike) {
        this.onHeartActivated = true;
      } else {
        this.onHeartDeactivated = true;
      }
    });
  }
  get btnRestock() {
    return CommonUtils.isApp()
      ? this.$t("order.a0024")
      : this.$t("order.a0038");
  }
  // 상단 장바구니 버튼
  btnCartHeader(): void {
    axios.get("/login/ping").then((r) => {
      if (r.data != "pong") {
        this.$router.push({ name: "Login", params: { toName: "OrderCart" } });
        return;
      } else {
        this.$router.push({ name: "OrderCart" });
      }
    });
  }

  // GTag 전송
  sendAnayticsLogEvents(eventName: string) {
    const requestVO: GTagEventRequestVO = {} as GTagEventRequestVO;
    requestVO.value = this.product.salePrice;
    requestVO.currency = this.$data.mainCurrencyNm;
    requestVO.items = [];

    const item: ItemsVO = {} as ItemsVO;
    item.itemId = this.product.productCd;
    item.itemName = this.product.productNm;
    item.itemBrand = this.product.brandNm;
    item.itemCategory = this.product.cateNm;
    item.discount = this.product.discountPrice;
    item.price = this.product.salePrice;
    item.itemVariant = this.product.skuCd;

    requestVO.items.push(item);
    const eventParam = CommonUtils.toSnakeCase(requestVO);

    CommonUtils.sendCommonEventLogs(this, eventName, eventParam);
  }

  // 상품쿠폰 목록 조회
  btnProductCouponPop() {
    axios.get("/login/ping").then((r) => {
      if (r.data != "pong") {
        this.$router.push({
          name: "Login",
          params: { toName: "ProductCoupons" },
        });
        return;
      } else {
        this.$router.push({
          name: "ProductCoupons",
          params: { productCd: this.productCd },
        });
      }
    });
  }

  // 전성분임?
  isJsb(str: string): boolean {
    return str == "전성분" || str == "All ingredients";
  }


  // 재입고 알림
  async btnRestockNotification() {
    // 일단 로그인 체크하고
    await axios.get("/login/ping").then((r) => {
      if (r.data != "pong") {
        this.$router.push({
          name: "Login",
          params: {
            toName: "Product",
            productCd: this.currentProduct.productCd.toString(),
          },
        });
      } else {
        // 앱
        if (CommonUtils.isApp() == true) {
          this.btnRestockNotificationForApp();
          return;
        }
        // 모바일 웹
        if (confirm(this.$t("common.c0007").toString())) {
          // APP에서만 이용할 수 있는 서비스입니다.\nAPP으로 이동하시겠습니까?
          if (this.$isMobile) {
            // this.createDynamicLinks().then((r) => {
            //   location.href = r;
            // });
            location.href = `https://zikoo.co.kr/zlink?target=product/${this.product.productCd} `;
          } else {
            //pc에서 재입고알림 누를 시
            location.href = "https://www.zikoo.kr/";
          }
          return;
        }
      }
    });
  }

  fbPixelParams(): object {
    const orderCount = this.orderQuantityRaw;
    const { productCd, salePrice } = this.product;
    return {
      contents: [{ id: productCd.toString(), quantity: orderCount }],
      content_type: "product",
      value: salePrice * orderCount,
      currency: "KRW",
    } as FacebookVO;
  }

  // 재입고 알림(앱)
  async btnRestockNotificationForApp() {
    if (this.currentProduct.hasRestockNotification) {
      // 이미 재입고 신청 한 경우
      if (confirm(this.$t("product.c0005").toString()) == false) {
        // 이미 재입고 알림을 신청하셨습니다.\n재입고 알림 신청내역으로 이동하시겠습니까?
        return;
      }
    } else {
      if (confirm(this.$t("product.c0003").toString())) {
        // 재입고 시 앱푸시 알림이 발송됩니다. 알림을 받아보시겠습니까?
        let confirmed = false;
        await axios
          .post(`/product/${this.productCd}/restock-notification`)
          .then((r) => {
            confirmed = confirm(this.$t("product.c0004").toString()); // 재입고 알림 신청 완료!\n재입고 알림 신청내역으로 이동하시겠습니까?
          });
        if (!confirmed) {
          return;
        }
      }
    }

    this.$router.push({ name: "MyProducts", params: { tabIdx: "2" } });
  }

  // initialized events
  created(): void {
    axios.get(`/product/${this.productCd}`).then((r) => {
      this.product = r.data as ProductVO;
      this.currentProduct = r.data as ProductVO;
      this.meta = r.data.meta as OrderMetaVO;

      // 페이스북 픽셀 제품 조회 태그
      AdLogs.sendMetaPixelEventLogs("ViewContent", {
        content_ids: this.productCd,
        content_type: "product",
      });

      //크리테오 상품상세
      Criteo.putQuery({
        path: "",
        oneTag: Criteo.criteoTags.PRODUCT_TAG,
        data: [r.data],
      } as CriteoVO);

      CommonUtils.log(this.$route.name, this.product.memCd, {
        pc: this.productCd,
      });

      // 브라우저 타이틀
      CommonUtils.setDocumentTitle([
        this.product.brandNm,
        this.product.productNm,
      ]);
      // 메타 discription
      CommonUtils.setMetaDiscription(this.seoDescription);
      // 헤더 link href
      CommonUtils.setHeadLink(this.$route.fullPath.slice(1));
      CommonUtils.setMetaImage(this.product.images[0].fileUrl);
      // GTag 정보 전송
      this.sendAnayticsLogEvents(firebase.analytics.EventName.VIEW_ITEM);
      // 모비온 상품 정보 전송
      AdLogs.sendMobionProductDetail({
        productCode: this.product.productCd,
        productName : this.product.productNm,
        price: this.product.orgPrice,
        dcPrice: this.product.salePrice
      });
      // 최근 본 상품 추가
      this.addRecentProduct();

      // 장바구니 및 바로 결제 시 로그인 하고 화면으로 다시 돌아올 경우 && 구매권한이 있으면
      if (
        this.$route.params.toName &&
        this.currentProduct.gradePermitted &&
        this.$route.params.count
      ) {
        this.orderQuantityRaw = Number(this.$route.params.count);

        // 구매창 다시 띄워주기
        this.showGroups = true;
      }
    });

    window.addEventListener("scroll", this.handleScroll);
  }

  mounted() {
    document.dispatchEvent(new Event("render-complete"));
  }

  getMoreProductDetail() {
    axios
      .get(`/product/detail/${this.productCd}`, {
        params: {
          productCd: this.product.productCd,
          brandCd: this.product.brandCd,
        },
      })
      .then((r) => {
        this.product.categoryProducts = r.data.categoryProducts;
        this.product.brandProducts = r.data.brandProducts;
        this.product.cbViewProducts = r.data.cbViewProducts;
        this.product.cbOrderProducts = r.data.cbOrderProducts;
      });
  }

  activated() {
    window.addEventListener("scroll", this.handleScroll);
  }

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  deactivated() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  detailMore() {
    this.$nextTick(() => {
      this.currentScrollOffset;
    });
  }
}
